module.exports = [{
      plugin: require('/Users/maigo999/gatstrap/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":""},
    },{
      plugin: require('/Users/maigo999/gatstrap/node_modules/gatsby-plugin-catch-links/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/maigo999/gatstrap/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/maigo999/gatstrap/node_modules/gatsby-plugin-twitter/gatsby-browser'),
      options: {"plugins":[]},
    }]
